// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6038":"695dfa72","6406":"fcdcf9c8","6658":"42a2e069","8347":"2f479c08"}[chunkId] + ".chunk.css";
};